import { Component, Input } from '@angular/core'
import { AgRendererComponent } from 'ag-grid-angular'

@Component({
  selector: 'app-actionbuttons-column-renderer',
  template: `
    <a
      *ngIf="hasLink"
      [routerLink]="[url]"
      class="btn btn-link {{ canEdit ? '' : 'hidden' }} {{ disable ? 'disabled' : '' }}"
      style="padding: 0; margin-right: 15px;"
    >
      <i class="fa fa-edit"></i> Edit
    </a>

    <button
      *ngIf="!hasLink"
      class="btn btn-link {{ canEdit ? '' : 'hidden' }} {{ disable ? 'disabled' : '' }}"
      style="padding: 0; margin-right: 15px; {{ disable ? 'pointer-events: none;' : '' }}"
      (click)="editClicked()"
    >
      <i class="fa fa-edit"></i> Edit
    </button>

    <button
      class="btn btn-link {{ canDelete ? '' : 'hidden' }} {{ disable ? 'disabled' : '' }}"
      style="padding: 0; {{ disable ? 'pointer-events: none;' : '' }}"
      (click)="deleteClicked()"
    >
      <i class="fa fa-remove"></i> Delete
    </button>
  `,
  standalone: false
})
export class ActionButtonsColumnRendererComponent implements AgRendererComponent {
  private params: any

  @Input() canEdit = true
  @Input() canDelete = true
  @Input() hasLink = true
  @Input() disable = false
  url: any

  agInit(params: any): void {
    this.params = params
    this.canEdit = params.context.canEdit
    this.canDelete = params.context.canDelete
    this.url = this.params.data.Id
    this.disable = this.params.disable
    this.hasLink = this.params.hasLink
  }

  refresh(params: any): boolean {
    return false
  }

  public editClicked(): void {
    if (this.canEdit && this.params.context.editHandler) {
      this.params.context.editHandler(this.params.data)
    }
  }

  public deleteClicked(): void {
    if (this.canDelete && this.params.context.deleteHandler) {
      this.params.context.deleteHandler(this.params.data)
    }
  }
}
